import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useIdentity } from './IdentityContext';
import { INK } from '../theme';
import '../components/Loader.css';

export default function RequireIdentity() {
  const { user, initializing } = useIdentity();

  if (initializing) {
    return (
      <div style={{ background: INK, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span className="ij-loader" />
      </div>
    );
  }

  if (!user) return <Navigate to="/admin/login" replace />;

  return <Outlet />;
}
